import toast from 'react-hot-toast';
import JxtToast from '../components/JxtToast';
import { JxtToastVariantEnum } from '../components/JxtToast/types';

const DEFAULT_TOAST_DURATION = 4000;

export const generateToast = (
  title: string,
  isError: boolean,
  subtitle?: string,
  children?: React.ReactNode,
  duration?: number
) => {
  toast.custom(
    (newToast) => (
      <JxtToast
        variant={isError ? JxtToastVariantEnum.Failure : JxtToastVariantEnum.Success}
        onHide={() => toast.remove(newToast.id)}
        title={title}
        subtitle={subtitle}
      >
        {children}
      </JxtToast>
    ),
    {
      position: 'bottom-left',
      duration: duration ?? DEFAULT_TOAST_DURATION,
    }
  );
};
